module.exports = __webpack_public_path__ + "static/media/c.05c44ffe.png";